import React from 'react';
import Router from './routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ErrorProvider } from './components/SnackbarError/ErrorContext';
import SnackbarError from './components/SnackbarError/SnackbarError';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

const queryClient = new QueryClient();

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <ErrorProvider>
            <SnackbarError />
            <Router />
          </ErrorProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </>
  );
}

export default App;